import useReduceStore from 'hooks/ReduceStoreHook';
import SessionStore from 'stores/SessionStore';
import DesignerStore from 'stores/DesignerStore';
import Dispatcher from 'service/Dispatcher';
import AppConstants from 'AppConstants';
import HttpService from 'service/HttpService';

import UserAPI from 'service/api/UserAPI';

export const useCurrentSession = function() {
    const session = useReduceStore(SessionStore, (store) => store.getCurrentSession(), 
                            () => Dispatcher.dispatchAlertWithAction(AppConstants.LOGIN_TO_CONTINUE_MSG, "WARN"), []);

    return session;
}


export const userDesignerInfo = function(userId) {
    const userInfo = useReduceStore(DesignerStore, (store) => store.getDesignerInfo(userId), 
                                () => HttpService.getUserBasicInfo(null, userId), [userId]);
    return userInfo;
}

export const userStoreInfo = function(storeName) {
    const storeInfo = useReduceStore(DesignerStore, (store) => store.getStoreInfo(storeName), 
                                () => HttpService.getUserBasicInfo(storeName, null), [storeName]);
    return storeInfo;
}

export const usePopularStores = function() {
    const stores = useReduceStore(DesignerStore, (store) => store.getPopularStores(), 
                            () => HttpService.getPopularStores(), []);

    return stores;
}

export const usePopularInfluencers = function() {
    const stores = useReduceStore(DesignerStore, (store) => store.getPopularInfluencers(), 
                            () => HttpService.getPopularStores(), []);

    return stores;
}

/** Note: Code Smell because as of now, same API returns both Stores and Influencers */
export const useStoresAndInfluencers = function() {
    const stores = useReduceStore(DesignerStore, (store) => {
            return store.getAllPopularStores();
        }, () => HttpService.getPopularStores(), []);

    return stores;
}

export const useAllStores = function() {
    const stores = useReduceStore(DesignerStore, (store) => store.getAllStores(), 
                            () => UserAPI.getAllStores(), []);

    return stores;
}

export const useActiveArtist = function() {
    const stores = useReduceStore(DesignerStore, (store) => store.getActiveArtists(), 
                            () => UserAPI.getActiveArtists(), []);

    return stores;
}


export const useAllArtist = function(prefix) {
    const stores = useReduceStore(DesignerStore, (store) => store.getAllArtist(prefix), 
                            () => UserAPI.getAllArtist(prefix), [prefix]);

    return stores;
}


// WEBPACK FOOTER //
// ./src/hooks/UserHook.js